import { IS_NO_ROBOT_INDEX } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';

const baseSEO = {
  title: WEB_TITLE,
  description: WEB_DESC,
  openGraph: {
    type: 'article',
    locale: 'th_TH',
    url: WEB_URL.WEB,
    title: WEB_TITLE,
    description: WEB_DESC,
    site_name: WEB_NAME,
    images: [
      {
        url: IMAGE_DEFAULT,
        width: '750',
        height: '422',
        alt: WEB_NAME
      }
    ]
  },
  additionalMetaTags: [
    {
      name: 'keywords',
      content: WEB_KEYWORD
    }
  ]
};

const SEO = {
  ...baseSEO,
  noindex: IS_NO_ROBOT_INDEX,
  nofollow: IS_NO_ROBOT_INDEX
};

const SEOFORTAG = {
  ...baseSEO,
  noindex: IS_NO_ROBOT_INDEX,
  nofollow: false
};

export { SEOFORTAG };
export default SEO;
